import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTopicPage_Views_TopicQuery, ItemType, TopicPage_Views_Topic_ItemOrDirectChildUpdatedDocument, TopicPage_Views_Topic_LabelsUpdatedDocument } from "sprout-graphql";
import { Glitch, NotFound } from "@sprout/views";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import Head from "@sprout/client-layout/dist/Head";
import TrackJumpHistory from "@sprout/client-components/dist/TrackJumpHistory";
import FeatureFlaggedSubscription from "@sprout/client-lib/dist/FeatureFlaggedSubscription";
import { getItemUrl } from "sprout-lib";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import TopicPagePage from "../TopicPage_Page";
import useTopicPageCreatePost from "../graphql/mutations/useTopicPageCreatePost";
import TopicPageViewsTopicMain from "./TopicPage_Views_Topic_Main";
import TopicPageViewsTopicTopicButtons from "./TopicPage_Views_Topic_TopicButtons";
import { TopicPageViewsTopicEditorProvider } from "./TopicPageViewsTopicEditorContext";
import TopicPageViewsTopicToolbar from "./TopicPageViewsTopicToolbar";
const TopicPageViewsTopic = ()=>{
    var ref;
    const { topicId  } = useParams();
    const { data , loading , error  } = useTopicPage_Views_TopicQuery({
        variables: {
            topicId: Number(topicId)
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
    });
    const topic = data === null || data === void 0 ? void 0 : data.topic;
    const isInitialLoad = loading && !topic;
    useLoadingProgress(isInitialLoad);
    const createPost = useTopicPageCreatePost();
    const showSnackbar = useSnackbar();
    const handleDrop = useCallback((item)=>{
        createPost({
            context: "page",
            topicNodeId: undefined,
            variables: {
                parentTopicId: Number(topicId),
                description: item.type === "text" ? item.content : null,
                url: item.type === "url" ? item.content : null
            }
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        createPost,
        showSnackbar,
        topicId
    ]);
    if (isInitialLoad) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!topic || topic.type !== ItemType.Topic || ((ref = topic.rootTopicOrSelf) === null || ref === void 0 ? void 0 : ref.special) === "PROFILE") return /*#__PURE__*/ _jsx(NotFound, {});
    const { title , linkImages , description , id , rootTopicOrSelf , isRootTopic  } = topic;
    const metaTagImage = linkImages && linkImages[0];
    const goBackURL = isRootTopic ? undefined : getItemUrl(topic.parentTopic, rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.owner);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TrackJumpHistory, {
                type: ItemType.Topic,
                data: {
                    itemId: id,
                    view: "HOME"
                }
            }),
            /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                subscription: TopicPage_Views_Topic_ItemOrDirectChildUpdatedDocument,
                variables: {
                    topicId: id
                }
            }),
            rootTopicOrSelf && /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                subscription: TopicPage_Views_Topic_LabelsUpdatedDocument,
                variables: {
                    topicId: rootTopicOrSelf.id
                }
            }),
            /*#__PURE__*/ _jsx(Head, {
                title: title ? `${title} | Sprout` : "Sprout",
                description: description,
                image: metaTagImage
            }),
            /*#__PURE__*/ _jsx(TopicPageViewsTopicEditorProvider, {
                children: /*#__PURE__*/ _jsx(TopicPagePage, {
                    onDrop: handleDrop,
                    goBackURL: goBackURL,
                    topic: topic,
                    main: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(TopicPageViewsTopicMain, {
                                topic: topic
                            }),
                            /*#__PURE__*/ _jsx(TopicPageViewsTopicToolbar, {
                                topic: topic
                            })
                        ]
                    }),
                    appBar: /*#__PURE__*/ _jsx(TopicPageViewsTopicTopicButtons, {
                        topic: topic
                    })
                })
            })
        ]
    });
};
export default TopicPageViewsTopic;
